// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"638dac7b","732":"7f4997b4","977":"540eeb15"}[chunkId] + ".chunk.js";
};